import type { GraphTagVendor } from '@axilon-apps/domains-ontology-ui-state'

// Ignition rows carry no badge because their provider-prefixed path already
// identifies the source.
export const TAG_VENDOR_LABEL: Record<GraphTagVendor, string | null> = {
  ignition: null,
  aveva: 'AVEVA',
  factorysim: 'FactorySim',
  opc: 'OPC',
  db: 'DB',
  mtconnect: 'MTC',
  pi: 'PI',
  canary: 'Canary',
  unknown: null
}
